import React, { useEffect, useState } from "react";
import styles from "./style.module.scss";
import MonitorPieChart from "./MonitorPieChart";
import { useDispatch } from "react-redux";
import {
	closeLoader,
	openLoader,
} from "../../redux/actions/loader/loaderActions";
import { openToastAndSetContent } from "../../redux/actions/toast/toastActions";
import axios from "axios";

let wsURL: any = "";

const wsUrlDev =
	"ws://itexpay-admin-alb-staging-133804970.us-west-2.elb.amazonaws.com:8080/monitor/server";

const wsUrlProd = "wss://admin-ws.itexpay.com/monitor/server";

const MonitorServers = (): JSX.Element => {
	if (window.location.href.includes("admin.itexpay.com-staging-env")) {
		wsURL = wsUrlDev;
	} else {
		wsURL = wsUrlProd;
	}

	const dispatch = useDispatch();

	const [services, setServices] = useState<any>();
	const [response, setResponse] = useState<any>({});

	let ws: WebSocket | null = null;

	const connectWebSocket = (): void => {
		ws = new WebSocket(wsURL);

		ws.onopen = () => {
			// console.log("connected", new Date().toLocaleTimeString());
		};

		ws.onmessage = (event: MessageEvent) => {
			if (event) {
				const { data } = JSON.parse(event.data);
				if (data) {
					setServices(data);
				}
			}
		};

		ws.onclose = () => {
			// console.log("disconnected", new Date().toLocaleTimeString());

			// Try to reconnect after a short delay
			setTimeout(() => {
				connectWebSocket();
				// console.log("connected", new Date().toLocaleTimeString());
			}, 100); // Adjust the delay as needed
		};
	};

	useEffect(() => {
		connectWebSocket();

		// Clean up the WebSocket connection and mounted flag when the component unmounts
		return () => {
			if (ws) {
				ws.close();
			}
		};
	}, []);

	useEffect(() => { }, [services]);

	const getServicesInfo = async () => {
		dispatch(openLoader());

		try {
			const response: any = await axios.get(`v1/monitor/server`);
			setServices(response?.data?.report);
		} catch (err: any) {
			dispatch(
				openToastAndSetContent({
					toastContent:
						err.response?.data?.message ||
						err?.data?.message ||
						err?.message ||
						err,
					toastType: "error",
				})
			);
		} finally {
			dispatch(closeLoader());
		}
	};

	useEffect(() => {
		getServicesInfo();
	}, []);

	const ChartSection = ({
		header,
		content,
		responseData,
		percentage,
		colors,
		addStyles,
	}: any) => {
		return (
			<div style={addStyles} className={styles.diskUsage}>
				<h2>{header}</h2>
				<div className={styles.chartContainer}>
					<div>
						<MonitorPieChart
							responseData={responseData}
							percentage={percentage}
							colors={colors}
						/>
					</div>
					<p>{content}</p>
				</div>
			</div>
		);
	};

	const OverviewFailureTable = ({ data }: any) => {
		const [selectedService, setSelectedService] = useState("backend");
		const [active, setActive] = useState<any>({});

		useEffect(() => {
			if (!data) {
				return;
			}
			const service = data[selectedService];
			if (service) {
				setActive(service);
			} else {
				setActive({});
			}
		}, [selectedService, data]);

		return (
			<div>
				<p style={{ paddingBottom: "10px" }}>
					(Exceptions count : {active?.exceptions})
				</p>
				<select
					value={selectedService} // ...force the select's value to match the state variable...
					onChange={(e) => setSelectedService(e.target.value)} // ... and update the state variable on any change!
					style={{
						color: "white",
						width: "80%",
						padding: "10px",
						backgroundColor: "#000212",
						border: "1px solid white",
					}}
				>
					<option value="backend">Backend</option>
					<option value="core">Core</option>
					<option value="admin">Admin</option>
					<option value="merchant">Merchant</option>
					<option value="cards">Cards</option>
					<option value="settlement">Settlement</option>
					<option value="others">Others</option>
				</select>
				{active?.errors?.length > 0 ? (
					<div className={styles.itemWrapper}>
						{active?.errors?.map((err: any, i: number) => (
							<div key={i} className={styles.indexWrapper}>
								<span>{i + 1}</span>
								<p>{err}</p>
							</div>
						))}
					</div>
				) : (
					<p style={{ paddingTop: "20px" }}>No exceptions recorded</p>
				)}
			</div>
		);
	};

	return (
		<div className={styles.monitorContainer}>
			<div className={styles.topSection}>
				<div className={styles.allCharts}>
					{/* Backend Services */}
					<div style={{ textAlign: "left" }}>
						<h3 style={{ color: "white" }}>Backend Service</h3>
						<div className={styles.charts}>
							<ChartSection
								content={"Disk Usage"}
								percentage={services?.backend?.disk}
								colors={["#27AE60", "#151A20"]}
								responseData={[
									{
										name: "Group A",
										value: parseInt(services?.backend?.disk.slice(0, -1)) * 100,
									},
									{
										name: "Group B",
										value:
											(100 - parseInt(services?.backend?.disk.slice(0, -1))) *
											100,
									},
								]}
							/>
							<ChartSection
								content={"Memory Usage"}
								percentage={services?.backend?.memory}
								colors={["#27AE60", "#151A20"]}
								responseData={[
									{
										name: "Group A",
										value:
											parseInt(services?.backend?.memory.slice(0, -1)) * 100,
									},
									{
										name: "Group B",
										value:
											(100 - parseInt(services?.backend?.memory.slice(0, -1))) *
											100,
									},
								]}
							/>
						</div>
					</div>

					{/* Core Service */}

					<div style={{ textAlign: "left" }}>
						<h3 style={{ color: "white" }}>Core Service</h3>
						<div className={styles.charts}>
							<ChartSection
								content={"Disk Usage"}
								percentage={services?.core?.disk}
								colors={["#27AE60", "#151A20"]}
								responseData={[
									{
										name: "Group A",
										value: parseInt(services?.core?.disk.slice(0, -1)) * 100,
									},
									{
										name: "Group B",
										value:
											(100 - parseInt(services?.core?.disk.slice(0, -1))) * 100,
									},
								]}
							/>
							<ChartSection
								content={"Memory Usage"}
								percentage={services?.core?.memory}
								colors={["#27AE60", "#151A20"]}
								responseData={[
									{
										name: "Group A",
										value: parseInt(services?.core?.memory.slice(0, -1)) * 100,
									},
									{
										name: "Group B",
										value:
											(100 - parseInt(services?.core?.memory.slice(0, -1))) *
											100,
									},
								]}
							/>
						</div>
					</div>

					{/* Admin Service */}
					<div style={{ textAlign: "left" }}>
						<h3 style={{ color: "white" }}>Admin Service</h3>
						<div className={styles.charts}>
							<ChartSection
								content={"Disk Usage"}
								percentage={services?.admin?.disk}
								colors={["#27AE60", "#151A20"]}
								responseData={[
									{
										name: "Group A",
										value: parseInt(services?.admin?.disk.slice(0, -1)) * 100,
									},
									{
										name: "Group B",
										value:
											(100 - parseInt(services?.admin?.disk.slice(0, -1))) *
											100,
									},
								]}
							/>
							<ChartSection
								content={"Memory Usage"}
								percentage={services?.admin?.memory}
								colors={["#27AE60", "#151A20"]}
								responseData={[
									{
										name: "Group A",
										value: parseInt(services?.admin?.memory.slice(0, -1)) * 100,
									},
									{
										name: "Group B",
										value:
											(100 - parseInt(services?.admin?.memory.slice(0, -1))) *
											100,
									},
								]}
							/>
						</div>
					</div>

					{/* Merchant Service */}
					<div style={{ textAlign: "left" }}>
						<h3 style={{ color: "white", paddingTop: "10px" }}>
							Merchant Service
						</h3>
						<div className={styles.charts}>
							<ChartSection
								content={"Disk Usage"}
								percentage={services?.merchant?.disk}
								colors={["#27AE60", "#151A20"]}
								responseData={[
									{
										name: "Group A",
										value:
											parseInt(services?.merchant?.disk.slice(0, -1)) * 100,
									},
									{
										name: "Group B",
										value:
											(100 - parseInt(services?.merchant?.disk.slice(0, -1))) *
											100,
									},
								]}
							/>
							<ChartSection
								content={"Memory Usage"}
								percentage={services?.merchant?.memory}
								colors={["#27AE60", "#151A20"]}
								responseData={[
									{
										name: "Group A",
										value:
											parseInt(services?.merchant?.memory.slice(0, -1)) * 100,
									},
									{
										name: "Group B",
										value:
											(100 -
												parseInt(services?.merchant?.memory.slice(0, -1))) *
											100,
									},
								]}
							/>
						</div>
					</div>
					{/* Cards Service */}
					<div style={{ textAlign: "left" }}>
						<h3 style={{ color: "white", paddingTop: "10px" }}>Card Service</h3>
						<div className={styles.charts}>
							<ChartSection
								content={"Disk Usage"}
								percentage={services?.cards?.disk}
								colors={["#27AE60", "#151A20"]}
								responseData={[
									{
										name: "Group A",
										value: parseInt(services?.cards?.disk.slice(0, -1)) * 100,
									},
									{
										name: "Group B",
										value:
											(100 - parseInt(services?.cards?.disk.slice(0, -1))) *
											100,
									},
								]}
							/>
							<ChartSection
								content={"Memory Usage"}
								percentage={services?.cards?.memory}
								colors={["#27AE60", "#151A20"]}
								responseData={[
									{
										name: "Group A",
										value: parseInt(services?.cards?.memory.slice(0, -1)) * 100,
									},
									{
										name: "Group B",
										value:
											(100 - parseInt(services?.cards?.memory.slice(0, -1))) *
											100,
									},
								]}
							/>
						</div>
					</div>

					{/* Settlement Service */}
					<div style={{ textAlign: "left" }}>
						<h3 style={{ color: "white", paddingTop: "10px" }}>
							Settlement Service
						</h3>
						<div className={styles.charts}>
							<ChartSection
								content={"Disk Usage"}
								percentage={services?.settlement?.disk}
								colors={["#27AE60", "#151A20"]}
								responseData={[
									{
										name: "Group A",
										value:
											parseInt(services?.settlement?.disk.slice(0, -1)) * 100,
									},
									{
										name: "Group B",
										value:
											(100 -
												parseInt(services?.settlement?.disk.slice(0, -1))) *
											100,
									},
								]}
							/>
							<ChartSection
								content={"Memory Usage"}
								percentage={services?.settlement?.memory}
								colors={["#27AE60", "#151A20"]}
								responseData={[
									{
										name: "Group A",
										value:
											parseInt(services?.settlement?.memory.slice(0, -1)) * 100,
									},
									{
										name: "Group B",
										value:
											(100 -
												parseInt(services?.settlement?.memory.slice(0, -1))) *
											100,
									},
								]}
							/>
						</div>
					</div>

					{/* Other Service */}
					<div style={{ textAlign: "left" }}>
						<h3 style={{ color: "white", paddingTop: "10px" }}>
							Other Service
						</h3>
						<div className={styles.charts}>
							<ChartSection
								content={"Disk Usage"}
								percentage={services?.others?.disk}
								colors={["#27AE60", "#151A20"]}
								responseData={[
									{
										name: "Group A",
										value: parseInt(services?.others?.disk.slice(0, -1)) * 100,
									},
									{
										name: "Group B",
										value:
											(100 - parseInt(services?.others?.disk.slice(0, -1))) *
											100,
									},
								]}
							/>
							<ChartSection
								content={"Memory Usage"}
								percentage={services?.others?.memory}
								colors={["#27AE60", "#151A20"]}
								responseData={[
									{
										name: "Group A",
										value:
											parseInt(services?.others?.memory.slice(0, -1)) * 100,
									},
									{
										name: "Group B",
										value:
											(100 - parseInt(services?.others?.memory.slice(0, -1))) *
											100,
									},
								]}
							/>
						</div>
					</div>
					<div></div>
				</div>
				<div className={styles.subSection}>
					<h2 className={styles.subHeader}>Latest Server Errors</h2>
					<OverviewFailureTable data={services} />
				</div>
			</div>
		</div>
	);
};

export default MonitorServers;
